import { render, staticRenderFns } from "./IssueStopReason.vue?vue&type=template&id=99f98896&scoped=true&"
import script from "./IssueStopReason.vue?vue&type=script&lang=ts&"
export * from "./IssueStopReason.vue?vue&type=script&lang=ts&"
import style0 from "./IssueStopReason.vue?vue&type=style&index=0&id=99f98896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f98896",
  null
  
)

export default component.exports